<template>
  <v-main class="public-form-page">
    <v-container class="py-8 py-md-12" style="max-width: 720px">
      <v-card outlined rounded="lg" class="pa-4 pa-md-10">
        <slot></slot>
      </v-card>
    </v-container>
  </v-main>
</template>

<script>
export default {};
</script>

<style lang="sass" scoped>
.public-form-page
  background-color: #f5f3fb
  min-height: 100vh
</style>
